// import SliderService from "../../../services/SliderService";

export default {
    namespaced: true,
    state: () => ({
        sliderListesi: []
    }),
    mutations: {
    },
    actions: {
    }
}